import { X, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useImpersonation } from '../hooks/useImpersonation';

/**
 * Banner displayed at the top of the portal when an admin is impersonating a contact.
 * Shows the impersonation status, access mode, and provides an "End Impersonation" button.
 */
export function ImpersonationBanner() {
  const { isImpersonation, adminUserName, endImpersonation } =
    useImpersonation();

  // Don't show anything if not impersonating
  if (!isImpersonation) {
    return null;
  }

  return (
    <div className={`bg-orange-500 text-white px-4 py-2`}>
      <div className="flex items-center justify-between max-w-screen-2xl mx-auto">
        {/* Left side - Status info */}
        <div className="flex items-center gap-3 flex-wrap">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4" />
            <span className="font-medium">Admin Impersonation</span>
          </div>

          {adminUserName && (
            <>
              <span className="hidden lg:inline text-white/80">|</span>
              <span className="hidden lg:inline text-white/70 text-sm">
                by {adminUserName}
              </span>
            </>
          )}
        </div>

        {/* Right side - End button */}
        <Button
          variant="ghost"
          size="sm"
          onClick={endImpersonation}
          className="text-white hover:bg-white/20 hover:text-white flex items-center gap-1.5"
        >
          <X className="h-4 w-4" />
          <span className="hidden sm:inline">End Impersonation</span>
        </Button>
      </div>
    </div>
  );
}
